import { Component, OnInit, Input } from '@angular/core';
import { cardTypes } from '../card/cardtypes';
import { Router } from '@angular/router';

@Component({
  selector: 'takeoff-group-sub-nav',
  templateUrl: './sub-nav.component.html',
  styleUrls: ['./sub-nav.component.css']
})
export class SubNavComponent implements OnInit {
  @Input('sub-nav-list') subNavList;
  cardTypesenum = cardTypes;
  constructor(private router: Router) { }

  ngOnInit() {
  }

  onLinkClick(selectedNav) {
    this.subNavList = this.subNavList.map(item => {
      return { ...item, isActive: item.title === selectedNav.title ? true : false };
    });
    this.router.navigate([selectedNav.url]);
  }
}
